var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinkHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3447 1.04682L6.30469 1.63682C4.65469 1.98682 3.21469 2.97682 2.28469 4.38682L1.42469 5.69682C0.744687 6.72682 0.374688 7.93682 0.374688 9.17682L0.304688 19.6968C0.304688 20.1668 0.354688 20.6468 0.454688 21.1068L1.17469 24.4268C1.74469 27.0468 3.88469 27.5168 6.54469 27.8868L11.8747 28.6468C12.4747 28.7268 13.0747 28.7268 13.6747 28.6468L18.8247 27.9168C21.5747 27.5268 23.7547 26.9468 24.2447 24.2068L25.0847 19.4768C25.1447 19.1468 25.1747 18.8068 25.1847 18.4768L25.3347 7.97682C25.3547 7.11682 25.3347 6.81682 25.1147 6.02682L24.8847 5.47682C23.9947 3.25682 21.9547 1.71682 19.5747 1.46682L13.8147 0.71682C13.1447 0.64682 10.9947 0.90682 10.3447 1.04682Z",
    fill: "url(#paint0_linear_3235_2847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4653 28.6966H12.0853C10.9353 28.6966 10.0353 27.6966 10.1553 26.5566L10.5453 22.7166C10.6453 21.7266 11.4853 20.9766 12.4753 20.9766H13.0653C14.0653 20.9766 14.8953 21.7266 14.9953 22.7166L15.3853 26.5566C15.5053 27.7066 14.6053 28.6966 13.4553 28.6966H13.4653Z",
    fill: "url(#paint1_linear_3235_2847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0355 5.06641H6.25547C3.54547 5.06641 1.35547 7.26641 1.35547 9.96641V13.2464C1.35547 16.4164 3.12547 19.3264 5.94547 20.7864L9.14547 22.4364C11.5855 23.6964 14.4855 23.6964 16.9255 22.4364L20.1255 20.7864C22.9455 19.3264 24.7155 16.4264 24.7155 13.2464V9.96641C24.7155 7.25641 22.5155 5.06641 19.8155 5.06641H13.0355Z",
    fill: "url(#paint2_linear_3235_2847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 3.95664L12.5539 4.99664C12.5539 4.99664 12.5239 5.07664 12.4839 5.09664L6.81391 7.97664L2.67391 9.88664C2.67391 9.88664 2.61391 9.93664 2.60391 9.97664L1.00391 18.1266C0.973906 18.2766 0.753906 18.2566 0.753906 18.1066V7.41664C0.753906 7.41664 0.763906 7.34664 0.793906 7.32664L5.14391 3.09664C5.14391 3.09664 5.20391 3.05664 5.24391 3.05664L12.5939 3.80664C12.6639 3.80664 12.7139 3.87664 12.7039 3.95664H12.7139Z",
    fill: "#BD8E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.385 9.79788C22.385 9.79788 22.455 9.84789 22.465 9.88789L24.715 15.7079C24.775 15.8779 25.025 15.8279 25.025 15.6479V8.04788C25.025 8.04788 25.005 7.96788 24.975 7.92788L19.925 3.01788C19.925 3.01788 19.845 2.96788 19.795 2.97788L12.495 3.72788C12.405 3.72788 12.335 3.81788 12.355 3.90788L12.505 4.89788C12.505 4.94788 12.545 4.99788 12.595 5.01788L18.245 7.88788L22.385 9.79788Z",
    fill: "#BD8E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1344 11.3164C19.5744 11.5864 19.8744 12.0664 19.8744 12.6164C19.8744 13.4564 19.1944 14.1464 18.3444 14.1464C17.4944 14.1464 16.8144 13.4664 16.8144 12.6164C16.8144 12.1564 17.0144 11.7564 17.3344 11.4764C16.1744 12.1164 15.4844 13.7064 15.4844 13.7064C15.4844 13.7064 16.4444 15.7264 18.3444 15.4864C20.2444 15.2364 21.2044 13.7064 21.2044 13.7064C21.1244 12.7364 20.3544 11.6464 19.1344 11.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8147 12.6268C16.8147 13.4668 17.4947 14.1568 18.3447 14.1568C19.1947 14.1568 19.8747 13.4768 19.8747 12.6268C19.8747 12.0768 19.5747 11.5868 19.1347 11.3268C18.8647 11.2468 18.5647 11.2168 18.2547 11.2168C17.9247 11.2168 17.6147 11.3268 17.3247 11.4868C17.0047 11.7668 16.8047 12.1768 16.8047 12.6268H16.8147Z",
    fill: "#8CA5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2644 11.2273C19.9244 11.1773 21.0344 12.4473 21.1944 13.6073C21.1944 13.5973 21.2144 13.5873 21.2144 13.5873C21.1144 12.3973 19.9844 11.0373 18.2644 11.0873C16.5444 11.1373 15.4844 13.5873 15.4844 13.5873C15.4844 13.5873 15.4944 13.6173 15.5244 13.6573C15.7144 13.2473 16.7244 11.2773 18.2644 11.2373V11.2273Z",
    fill: "#755230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68523 11.3164C6.24523 11.5864 5.94523 12.0664 5.94523 12.6164C5.94523 13.4564 6.62523 14.1464 7.47523 14.1464C8.32523 14.1464 9.00523 13.4664 9.00523 12.6164C9.00523 12.1564 8.80523 11.7564 8.48523 11.4764C9.64523 12.1164 10.3352 13.7064 10.3352 13.7064C10.3352 13.7064 9.37523 15.7264 7.47523 15.4864C5.57523 15.2364 4.61523 13.7064 4.61523 13.7064C4.69523 12.7364 5.46523 11.6464 6.68523 11.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01508 12.6268C9.01508 13.4668 8.33508 14.1568 7.48508 14.1568C6.63508 14.1568 5.95508 13.4768 5.95508 12.6268C5.95508 12.0768 6.25508 11.5868 6.69508 11.3268C6.96508 11.2468 7.26508 11.2168 7.57508 11.2168C7.90508 11.2168 8.21508 11.3268 8.50508 11.4868C8.82508 11.7668 9.02508 12.1768 9.02508 12.6268H9.01508Z",
    fill: "#8CA5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56523 11.2273C5.90523 11.1773 4.79523 12.4473 4.63523 13.6073C4.63523 13.5973 4.61523 13.5873 4.61523 13.5873C4.71523 12.3973 5.84523 11.0373 7.56523 11.0873C9.28523 11.1373 10.3452 13.5873 10.3452 13.5873C10.3452 13.5873 10.3352 13.6173 10.3052 13.6573C10.1152 13.2473 9.10523 11.2773 7.56523 11.2373V11.2273Z",
    fill: "#755230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5452 17.5273C11.5452 17.5273 12.8552 18.2173 14.3552 17.5273C14.3552 17.5273 13.8052 18.5373 12.9452 18.5373C12.0852 18.5373 11.5352 17.5273 11.5352 17.5273H11.5452Z",
    fill: "#EAA2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93563 10.2974C9.93563 10.2974 7.86562 9.68741 7.47563 9.64741C7.08563 9.60741 5.20563 9.99741 5.20563 9.99741L3.76562 11.3874L5.40562 10.5174L7.47563 10.2974L9.93563 11.0774V10.2974Z",
    fill: "#BD8E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6055 10.2564C15.6055 10.2564 17.6755 9.64639 18.0655 9.60639C18.4555 9.56639 20.3355 9.9564 20.3355 9.9564L21.7755 11.3464L20.1355 10.4764L18.0655 10.2564L15.6055 11.0364V10.2564Z",
    fill: "#BD8E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1755 15.0664C12.5155 15.1364 13.2455 15.2564 13.8755 15.1064C13.9455 15.0864 13.9955 15.1764 13.9455 15.2264C13.6955 15.4764 13.2655 15.8764 13.0655 15.9464C12.8355 16.0264 12.3455 15.4664 12.1155 15.1864C12.0755 15.1364 12.1155 15.0664 12.1855 15.0764L12.1755 15.0664Z",
    fill: "url(#paint3_linear_3235_2847)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2847",
    x1: 12.7247,
    y1: 10.5868,
    x2: 13.5447,
    y2: 37.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#BD8E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D4AA7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5BF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F0CCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4D1AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2847",
    x1: 12.6053,
    y1: 19.6366,
    x2: 12.8053,
    y2: 27.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E7B0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFC7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2847",
    x1: 12.7955,
    y1: 4.03641,
    x2: 13.0955,
    y2: 13.6964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E7B0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFC7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2847",
    x1: 13.0355,
    y1: 16.6664,
    x2: 13.0355,
    y2: 14.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD9291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E19F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EAB8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1CBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F9E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.03,
    height: 27.99,
    fill: "white",
    transform: "translate(0.304688 0.707031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkHead);
export default __webpack_public_path__ + "static/media/pink_head.616e1dff001d31b1ec02b51b2087104f.svg";
export { ForwardRef as ReactComponent };